export default "__VITE_ASSET__Cy8oDedM__"